<template>
	<div class="PageCustomerOverview">
		<div class="row margin-bottom-xlarge">
    		<div class="col-xs-12">
    			<h1 class="st-headline st-headline--1">{{ $t('Customers') }}</h1>
    		</div>
    	</div>

		<div class="row margin-bottom-xlarge margin-top-xlarge">
    		<div class="col-xs-12">
    			<UserList
				:apiurl="'/api/v1/customers'"
				:columns="['image', 'customernumber', 'this', 'leader', 'partners']"
				:listname="'customers'"
				></UserList>
    		</div>
    	</div>
	</div>
</template>

<script>
import UserList from '@/components/UserList';
export default {
	name: 'PageCustomerOverview',
	components: {
		UserList
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/PageCustomerOverview.vue